<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Rejected</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>

          <div class="card-header">
            <div style="width: 100%; margin: 0;">
              <selectlist
                name="handler_id"
                label="Handler"
                label-name="full_name"
                :options="handlers"
                :value="filters.handler_id"
                @input="setHandler"
                :stacked="true"
              ></selectlist>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Handler</th>
                  <th>Claim Reference</th>
                  <th>Claim Type</th>
                  <th>Client Name</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="incidents.length">
                <tr v-bind:key="index" v-for="(incident, index) in incidents">
                  <td>
                    {{ incident.handler?.full_name || 'Not Assigned' }}
                  </td>
                  <td>
                    {{ incident.source?.claim_reference || 'Not Provided' }}
                  </td>
                  <td>
                    {{
                      incident.source?.incident_claim_type?.label ||
                        'Not Provided'
                    }}
                  </td>
                  <td>
                    {{ incident.client?.full_name || 'Not Provided' }}
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-primary"
                      v-on:click.prevent="assignIncidentToHandler(incident)"
                      v-if="hasPermission('claims.reassign')"
                    >
                      {{
                        incident.handler ? 'Re-Assign Handler' : 'Not Assigned'
                      }}
                    </button>
                    <router-link
                      class="btn btn-primary"
                      :to="`/rejected/${incident.identifier}`"
                    >
                      View
                    </router-link>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!incidents.length">
                <tr>
                  <td colspan="7" class="text-center">
                    There are currently no rejected claims
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
              filter="status"
              filterParams="rejected"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <assign-handler
      :incident="incident"
      v-if="incident"
      :handlers="handlers"
      :show="modals.assign"
      v-on:close="closeAssignToHandlerModal"
      v-on:assigned="handlerWasAssigned"
    ></assign-handler>
  </div>
</template>

<script>
import AssignHandler from './../Shared/AssignHandler.vue';
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    AssignHandler,
    PageHeader
  },

  data() {
    return {
      paginator_data: {},
      incident: null,
      filters: {
        handler_id: null
      },
      modals: {
        assign: false
      },
      loading: false,
      incidents: []
    };
  },

  computed: {
    handlers() {
      return this.$store.getters['ClaimHandlers/all'];
    },

    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.findIncidents();
  },

  methods: {
    getData(url) {
      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      this.loading = true;

      window.Ajax.get(url)
        .then(response => {
          this.incidents = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    setHandler(handlerId) {
      this.filters.handler_id = handlerId;

      this.getData(
        `/incidents?filter[status]=rejected&per_page=${this.perPage}`
      );
    },

    handlerWasAssigned() {
      this.modals.assign = false;
      this.incident = null;
      this.findIncidents();

      window.toastify.success('Assigned', 'The case was assigned.');
    },

    closeAssignToHandlerModal() {
      this.modals.assign = false;
    },

    assignIncidentToHandler(incident) {
      this.incident = incident.identifier;
      this.modals.assign = true;
    },

    findIncidents() {
      this.getData(
        `/incidents?filter[status]=rejected&per_page=${this.perPage}`
      );
    }
  }
};
</script>
